import { Card, ListGroup, Badge } from 'react-bootstrap';

const TenantStatusSummary = ({ tenants }) => {
  return (
    <Card>
      <Card.Header>Tenants by Status</Card.Header>
      <ListGroup variant="flush">
        <ListGroup.Item>
          Active <Badge bg="success">{tenants.active}</Badge>
        </ListGroup.Item>
        <ListGroup.Item>
          Trial <Badge bg="warning" text="dark">{tenants.trial}</Badge>
        </ListGroup.Item>
        <ListGroup.Item>
          Suspended <Badge bg="danger">{tenants.suspended}</Badge>
        </ListGroup.Item>
      </ListGroup>
    </Card>
  );
};

export default TenantStatusSummary;
